// apps/web/src/components/BarcodeIcon.tsx
export function BarcodeIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className={className} aria-hidden>
      <rect x="3"  y="5" width="1" height="14" />
      <rect x="5"  y="5" width="2" height="14" />
      <rect x="8"  y="5" width="1" height="14" />
      <rect x="10" y="5" width="3" height="14" />
      <rect x="14" y="5" width="1" height="14" />
      <rect x="16" y="5" width="2" height="14" />
      <rect x="19" y="5" width="2" height="14" />
    </svg>
  );
}
